import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const CaptureIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.2405 9.2625A3.465 3.465 0 0 1 7.779 10.845c-.57.081-.9975.168-.9525.2625C4.4985 11.37 3.375 12.7605 3.375 14.361V27a3.375 3.375 0 0 0 3.375 3.375h22.5A3.375 3.375 0 0 0 32.625 27V14.361c0-1.6005-1.125-2.991-2.703-3.2535-.567-.0825-1.701-.2625-1.701-.2625a3.465 3.465 0 0 1-2.46-1.5825l-1.233-1.974a3.288 3.288 0 0 0-2.604-1.5585 73.161 73.161 0 0 0-7.848 0 3.288 3.288 0 0 0-2.604 1.5585l-1.2315 1.974Z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M24.75 19.125a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0ZM28.125 15.75h.012v.012h-.012V15.75Z"
      />
    </SvgIcon>
  );
};

export default CaptureIcon;

/*
      <path
        d="M21.75 6H14.25L10.5 10.5H6C5.20435 10.5 4.44129 10.8161 3.87868 11.3787C3.31607 11.9413 3 12.7044 3 13.5V27C3 27.7956 3.31607 28.5587 3.87868 29.1213C4.44129 29.6839 5.20435 30 6 30H30C30.7956 30 31.5587 29.6839 32.1213 29.1213C32.6839 28.5587 33 27.7956 33 27V13.5C33 12.7044 32.6839 11.9413 32.1213 11.3787C31.5587 10.8161 30.7956 10.5 30 10.5H25.5L21.75 6Z"
        stroke="currentColor"
        fill="none"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 24C20.4853 24 22.5 21.9853 22.5 19.5C22.5 17.0147 20.4853 15 18 15C15.5147 15 13.5 17.0147 13.5 19.5C13.5 21.9853 15.5147 24 18 24Z"
        stroke="currentColor"
        fill="none"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      */
